import { graphql } from '@/gql';

graphql(`
  fragment ValuesFields on ItemOptionsValuesType {
    id
    title
    subtitle
    price
    max
    min
    default
    nextCursor
  }
`);
